/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
==========================================================================================*/

import axios from '@/axios.js'
export default {


  payWithTerminal (context, paymentData) {
    // axios.defaults.headers.common['Authorization'] = 'Bearer '+context.state.token;
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`
    return new Promise((resolve, reject) => {
      axios.post(`${axios.defaults.baseURL  }/payment`, paymentData
      ).then(response => {
        context.commit('TERMINAL_PAYMENT')
        resolve(response)

      }).catch(error => {
        reject(error)
      })

    })

  }


}

